import React from 'react'

const SendButtonPopup = ({ sendingForm, formInputs, send, close, isSending }) => {
    return (
        <div className="my-dialog _small-dialog">
            <p className="send-button__text">Подтвердить отправку?</p>

            <div className="send-button-popup">
                <button className="my-button" onClick={send} disabled={isSending}>
                    {isSending ? 'Отправка...' : 'Да'}
                </button>
                <button className="my-button" onClick={close} disabled={isSending}>Нет</button>
            </div>
            
        </div>
    )
}

export default React.memo(SendButtonPopup)